// frontend/src/components/layout/mobile/mobileNav.js
//
// Where the phone layout sends the merchant: the four destinations of the
// bottom tab bar, and the More sheet that reaches every other screen. Plain
// data and functions, so navActive.test.js checks the real lists against the
// real route registry.

import { isNavPathActive } from '../navActive';
import { sidebarMenu, userMenu } from '../navMenus';

/** The bottom tab bar, left to right; More is the fifth slot. */
export const TABS = [
  { path: '/', labelKey: 'nav.home' },
  { path: '/inventory', labelKey: 'nav.inventory' },
  { path: '/purchase-recommendations', labelKey: 'mobileNav.purchaseCreate' },
  { path: '/purchase-orders', labelKey: 'mobileNav.purchaseManage' },
];

/** The fifth tab. */
export const MORE = 'more';

/** The tab lit on `pathname`: a TABS path, or MORE for every other screen. */
export function litTab(pathname) {
  const tab = TABS.find((entry) => isNavPathActive(entry.path, pathname));
  return tab ? tab.path : MORE;
}

/**
 * The More sheet's screens: the sidebar's the tab bar has no slot for, in the
 * sidebar's groups and order, then the user menu's. A sidebar section keeps
 * its title; a run of top-level pages becomes one untitled group.
 *
 * @param {{ isStaff: boolean, forecastOffered: boolean, store: object | null }} viewer  `store` is the selected store.
 * @returns {{ pages: { titleKey: string | null, links: object[] }[], store: { profile: object, links: object[] } | null, userProfile: object, tools: object[] }}
 */
export function moreMenu({ isStaff, forecastOffered, store }) {
  const notATab = (link) => !TABS.some((tab) => tab.path === link.path);
  const pages = [];
  for (const entry of sidebarMenu({ forecastOffered })) {
    if (entry.links) {
      const links = entry.links.filter(notATab);
      if (links.length > 0) pages.push({ titleKey: entry.labelKey, links });
    } else if (notATab(entry)) {
      const last = pages.at(-1);
      if (last && last.titleKey === null) last.links.push(entry);
      else pages.push({ titleKey: null, links: [entry] });
    }
  }
  return { pages, ...userMenu({ isStaff, store }) };
}

const EVERYTHING = moreMenu({ isStaff: true, forecastOffered: true, store: { id: 's', store_type: 'shopify' } });

/** Every link More can offer anyone — for the nav-highlight suites. */
export const ALL_MORE_LINKS = [
  ...EVERYTHING.pages.flatMap((section) => section.links),
  EVERYTHING.store.profile,
  ...EVERYTHING.store.links,
  EVERYTHING.userProfile,
  ...EVERYTHING.tools,
];
